module.exports = __webpack_public_path__ + "static/media/expert (7).f7412250.png";